module.exports = __webpack_public_path__ + "img/sns_share_3.6ba2c340.png";